import React from "react";
import { Link } from "react-router-dom";
import Button from "@components/ui/Button";

export default function NotFoundPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
      }}
    >
      <div
        style={{
          fontSize: 80,
          fontWeight: 800,
          color: "#006B3C",
          letterSpacing: -4,
        }}
      >
        404
      </div>
      <h1 style={{ fontSize: 24, fontWeight: 700 }}>Página não encontrada</h1>
      <p
        style={{
          fontSize: 14,
          color: "#6B7280",
          maxWidth: 400,
          textAlign: "center",
        }}
      >
        O caminho que você tentou acessar não existe ou foi movido.
      </p>
      <Link to="/">
        <Button variant="primary">Voltar ao dashboard</Button>
      </Link>
    </div>
  );
}
